import {getInfo} from "./user_info"
import {getDnsStream} from "./axios"

export function generateUrl (type, id, extension){
    const dns = getDnsStream();
    const user = getInfo().username;
    const pass = getInfo().password;
    
    // Forçamos o HTTPS no link do vídeo para o navegador não bloquear (Mixed Content)
    // O servidor qr56 suporta HTTPS e isso ignora a necessidade de proxy da VPS
    let baseDns = dns.replace("https://", "http://");
    baseDns = baseDns.endsWith('/') ? baseDns.slice(0, -1) : baseDns;
    
    const finalExtension = (type === "live") ? "ts" : (extension || "mp4");
    
    const rawUrl = `${baseDns}/${type}/${user}/${pass}/${id}.${finalExtension}`;
    
    if (window.cors) {
        return window.location.origin + "/stream.php?url=" + encodeURIComponent(rawUrl);
    }
    
    return rawUrl.replace("http://", "https://");
}

export function convertTsToM3u8(ip) {
    return ip ? ip.replace("http://", "https://") : ip; 
}

export function catchupUrlGenerator (ip,time, duration){
    let url = ip.replace("http://", "https://");
    time = timeConverter(time)
    url = url.replace("/live/","/").replace(/\.ts|\.m3u8/g,"")
    const splitted = url.split("/");

    const id = splitted[splitted.length-1];
    if(isNaN(id)) return ip;
    
    const user = splitted[splitted.length-3];
    const pass = splitted[splitted.length-2];
    const domain = splitted.slice(0,splitted.length-3).join("/");

    return domain + "/timeshift/" + user + "/" + pass + "/" + duration + "/" + time.split(":").slice(0,-1).join(":").replace(" ",":") + "/" + id + ".ts";
}

const timeConverter = (time) =>{
    const a = new Date(time);
    const year = a.getFullYear();
    const month = a.getMonth()+1;
    const day = a.getDate();
    const hour = a.getHours();
    const min = a.getMinutes();
    const sec = a.getSeconds();

    return year + "-" + (month < 10 ? "0"+month : month) + "-" + (day < 10 ? "0"+day : day) + " " + (hour < 10 ? "0"+hour : hour) + ':' + (min < 10 ? "0"+min : min) + ':' + (sec < 10 ? "0"+sec : sec);
};

export default {generateUrl, catchupUrlGenerator}
